import React from "react";
import "../src/styles/css/App.css";

import { BrowserRouter, Switch, Route } from "react-router-dom";
import Index from "./views/Index.jsx";
import Login from "./views/login/login.jsx";
import alerter from "./views/alerts/alerter.jsx";
import { ErrorAlert, SuccessAlert, InfoAlert } from "./views/alerts/alerts.jsx";

export default function App() {

  const [error, setError] = React.useState(null);
  const [errorEnabled, setErrorEnabled] = React.useState(false);
  const [success, setSuccess] = React.useState(null);
  const [successEnabled, setSuccessEnabled] = React.useState(false);
  const [info, setInfo] = React.useState(null);
  const [infoEnabled, setInfoEnabled] = React.useState(false);

  const alertListener = {
    onError: (error) => {
      setError(error);
      setSuccessEnabled(false);
      setErrorEnabled(true);
      setInfoEnabled(false);
    },
    onSuccess: (message) => {
      setSuccess(message);
      setErrorEnabled(false);
      setSuccessEnabled(true);
      setInfoEnabled(false);
    },
    onInfo: (info) => {
      setInfo(info);
      setInfoEnabled(true)
      setErrorEnabled(false);
      setSuccessEnabled(false);
    }
  }

  React.useEffect(() => {
    alerter.setListener(alertListener)
  }, []);

  return (
    <div className="App" style={{height : "100vh"}}>
      <div className="app-routes" style={{height : "100%"}}>
        <BrowserRouter basename={process.env.REACT_APP_BROWSE_ROUTE}>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route path="/" component={Index} />
          </Switch>
        </BrowserRouter>
      </div>

      <ErrorAlert
        open={errorEnabled}
        close={() => { setErrorEnabled(false) }}
        error={error}/>

      <SuccessAlert
        open={successEnabled}
        close={() => { setSuccessEnabled(false) }}
        message={success}/>

      <InfoAlert
        open={infoEnabled}
        close={() => { setInfoEnabled(false) }}
        info={info}/>

    </div>
  );
}
